import type { MouseEventHandler} from 'react';
import { useEffect, useState } from 'react';

import classNames from 'classnames';

import { Button } from '@uikit';

import { copyToClipboardWithToast } from '@shared/helpers/copyToClipboardWithToast';

export interface CopyInputProps {
  url: string;
}

export default function CopyInput({ url = '{{SHARING_LINK}}' }: CopyInputProps) {
  const [isCopied, setIsCopied] = useState(false);

  const handleInputClick: MouseEventHandler<HTMLInputElement> = (event) => {
    (event.target as HTMLInputElement).select();
  };

  useEffect(() => {
    if (!isCopied) {
      return;
    }

    const timeoutId = setTimeout(() => {
      setIsCopied(false);
    }, 3000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isCopied]);

  const handleCopyLinkButtonClick = () => {
    copyToClipboardWithToast(url);

    setIsCopied(true);
  };

  return (
    <div
      className={classNames(
        'w-full h-[40px] flex flex-grow rounded-full border border-secondary-600 overflow-hidden p-0',
      )}
    >
      <input
        readOnly
        type="text"
        value={url}
        onClick={handleInputClick}
        className="w-full truncate px-4 t-caption2"
      />

      <Button
        disabled={isCopied}
        variant="secondary"
        onClick={handleCopyLinkButtonClick}
        className="h-full whitespace-nowrap border-none"
      >
        {isCopied ? 'Link Copied' : 'Copy Link'}
      </Button>
    </div>
  );
}
